import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;



new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {
        //console.log(process.env);

        this.$store.dispatch("fillProductInfo").then(() => {
            this.$store.dispatch("fillMotifList").then(async() => {

                let criticalMotifs = [];
                //preloading first 2 cats of motifs
                for (let n = 0; n < 2; n++) {
                    for (let mi of this.$store.state.motifCatList[n].motifIndexes) {
                        criticalMotifs.push(this.$store.state.motifList[mi]);
                    }
                }
                //preloading product motifs if product is loaded
                if (this.$store.state.productMotifs != null) {
                    for (let pm of this.$store.state.productMotifs) {
                        criticalMotifs.push(pm.motifData);
                    }
                }
                await preloadAppImages(this.$store.state.productInfo.options[0].productOptions);
                await preloadMotifs(criticalMotifs); //await critical motifs

                preloadMotifs(this.$store.state.motifList); //no await on rest of motifs

                this.$mount("#app");
                document.getElementById("init").classList.add("loaded");

                setTimeout(function () {
                    document.getElementById("init").remove();
                }, 1000);

            });
        });
    },
    mounted() {
        //To Load External Libs
        //let recaptchaScript = document.createElement('script')
        //recaptchaScript.setAttribute('src', 'https://localhost/Scripts/classes.js')
        //document.head.appendChild(recaptchaScript)
    },
});

var imagesToPreLoad = [
    process.env.VUE_APP_ROOT_URL + '/images/custom-needlepoint-belt-sizing.png',
    process.env.VUE_APP_ROOT_URL + '/images/custom-needlepoint-belt.jpg',
    process.env.VUE_APP_ROOT_URL + '/images/bg-main.png',
    process.env.VUE_APP_ROOT_URL + '/images/stitches.png'
]


async function preloadAppImages(prodOptions) {

    for (let po of prodOptions) {
        imagesToPreLoad.push(po.productOptionOverlay);
        imagesToPreLoad.push(process.env.VUE_APP_ROOT_URL + '/images/product-overlays/option-' +
            po.productOptionId +
            '-1.png')
        imagesToPreLoad.push(process.env.VUE_APP_ROOT_URL + '/images/product-overlays/option-' +
            po.productOptionId +
            '-2.png')
        imagesToPreLoad.push('https://www.needlepaint.com/images/custom-needlepoint-belt-sizing.png')
        imagesToPreLoad.push('https://www.needlepaint.com/images/custom-needlepoint-dog-collar-sizing.png')
        imagesToPreLoad.push('https://www.needlepaint.com/images/stitches.png')
        imagesToPreLoad.push('https://www.needlepaint.com/images/bg-main.png')
        imagesToPreLoad.push('//brewsterbelt.myshopify.com/cdn/shop/files/Brewster_standard_1.png?v=1707854127&width=280')
    }
    try {
        await Promise.all(imagesToPreLoad.map(x => preloadImage(x)))
    } catch (error) {
        //
    }
}
async function preloadMotifs(motifs) {
    imagesToPreLoad = [];
    for (let m of motifs) {
        imagesToPreLoad.push(m.motifUrl);
    }
    try {
        await Promise.all(imagesToPreLoad.map(x => preloadImage(x)))
    } catch (error) {
        //
    }
}

const preloadImage = src =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = resolve
        image.onerror = reject
        image.src = src
    })

